import * as $ from 'jquery';
import { onClick, onClickOutsideOf, onLoad } from "Core/Events";

type Elements = {
  content: JQuery<HTMLElement>,
  trigger: JQuery<HTMLElement>,
}

export class CustomDropdown {
  private cssClasses = {
    visible: 'visible',
    arrowRotated: 'rotated',
  }
  private opened: boolean = false;
  private elements: Elements = {
    content: null,
    trigger: null,
  }
  private readonly arrowClassSelector = '.fa-chevron-down';

  constructor(elements: Elements) {
    this.elements = elements;
    this.assignEventListenersToTriggerElement(this.elements.trigger);
  }

  private assignEventListenersToTriggerElement(triggerElement: JQuery<HTMLElement>) {
    onClick(triggerElement, () => this.toggle(this.opened ? false : true));
    onClickOutsideOf(triggerElement, () => this.toggle(false));
  }

  toggle(onOrOff: boolean) {
    this.opened = onOrOff;
    this.elements.content.get(0).classList.toggle(this.cssClasses.visible, onOrOff);
    this.elements.trigger.get(0).querySelector(this.arrowClassSelector).classList.toggle(this.cssClasses.arrowRotated, onOrOff);   
  }
}

export const CustomDropdownInitializer = (() => {
  const Selector = {
    WHOLE_DROPDOWN: '[data-custom-dropdown]',
    TRIGGER: '[data-custom-dropdown-trigger]',
    CONTENT: '[data-custom-dropdown-content]',
  }

  onLoad(init);
  
  function init() {
    $(Selector.WHOLE_DROPDOWN).each((index, element) => {
      new CustomDropdown({
        content: $(element).find(Selector.CONTENT),
        trigger: $(element).find(Selector.TRIGGER),
      });
    });
  }
})();
import * as $ from 'jquery';
import { onClick, onClickOutsideOf, onLoad } from "Core/Events";

type Elements = {
  content: JQuery<HTMLElement>,
  trigger: JQuery<HTMLElement>,
}

export class CustomDropdown {
  private cssClasses = {
    visible: 'visible',
    arrowRotated: 'rotated',
  }
  private opened: boolean = false;
  private elements: Elements = {
    content: null,
    trigger: null,
  }
  private readonly arrowClassSelector = '.fa-chevron-down';

  constructor(elements: Elements) {
    this.elements = elements;
    this.assignEventListenersToTriggerElement(this.elements.trigger);
  }

  private assignEventListenersToTriggerElement(triggerElement: JQuery<HTMLElement>) {
    onClick(triggerElement, () => this.toggle(this.opened ? false : true));
    onClickOutsideOf(triggerElement, () => this.toggle(false));
  }

  toggle(onOrOff: boolean) {
    this.opened = onOrOff;
    this.elements.content.get(0).classList.toggle(this.cssClasses.visible, onOrOff);
    this.elements.trigger.get(0).querySelector(this.arrowClassSelector).classList.toggle(this.cssClasses.arrowRotated, onOrOff);   
  }
}

export const CustomDropdownInitializer = (() => {
  const Selector = {
    WHOLE_DROPDOWN: '[data-custom-dropdown]',
    TRIGGER: '[data-custom-dropdown-trigger]',
    CONTENT: '[data-custom-dropdown-content]',
  }

  onLoad(init);
  
  function init() {
    $(Selector.WHOLE_DROPDOWN).each((index, element) => {
      new CustomDropdown({
        content: $(element).find(Selector.CONTENT),
        trigger: $(element).find(Selector.TRIGGER),
      });
    });
  }
})();
